import React, { createContext, useState, useContext } from 'react';

const ShowSearchOverlayContext = createContext();

export default function ShowSearchOverlayProvider({ children }) {
    const [showSearchOverlay, setShowSearchOverlay] = useState(false);

    return (
        <ShowSearchOverlayContext.Provider value={{ showSearchOverlay, setShowSearchOverlay }}>
            {children}
        </ShowSearchOverlayContext.Provider>
    );
}

export function useShowSearchOverlay() {
    const context = useContext(ShowSearchOverlayContext);
    if (!context) return { showSearchOverlay: false, setShowSearchOverlay: () => {} };
    const { showSearchOverlay, setShowSearchOverlay } = context;
    return { showSearchOverlay, setShowSearchOverlay };
}
